import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useFormik } from 'formik';

import Container from '@mui/material/Container';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

import AppInput from 'shared/AppInput';
import AppNotification from 'shared/AppNotification';

import axios from 'utils/axios-rails';

const propTypes = {
  submitURL: PropTypes.string.isRequired,
}

const defaultProps = {

}

const GiftCardOrderNew = (props) => {
  const [message, setMessage] = useState(null);

  const closeToast = () => setMessage(null);

  const handleSubmit = async (values) => {
    console.log(values);
    try {
      const response = await axios.post(props.submitURL, {
        gift_card_order: values
      });
      formik.resetForm();
      setMessage(response.data.message);
    } catch (error) {
      const ex = error;
      console.log("MAX", error);
      if(error.response && error.response.data){
        formik.setErrors(error.response.data);
      } // errors
    }
    formik.setSubmitting(false);
  }

  const formik = useFormik({
    initialValues: {
      quantity: "",
      amount: "",
      notes: "",
    },
    onSubmit: handleSubmit
  });

  const { values, errors } = formik;

  return (
    <Container className="mt20">
      <AppNotification
        open={ !!message }
        message={ message }
        severity="success"
        handleClose={ closeToast }
        position={{ vertical: 'top', horizontal: 'right' }}
      />
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>Generar Gift Cards</Typography>
          <form onSubmit={ formik.handleSubmit } >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <AppInput
                  label="Cantidad"
                  name="quantity"
                  value={ values.quantity } onChange={ formik.handleChange } placeholder=""
                  error={ errors.quantity }
                  type="number"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <AppInput
                  label="Monto (Colones)"
                  attachedText="₡"
                  name="amount" value={ values.amount } onChange={ formik.handleChange } placeholder=""
                  error={ errors.amount } />
              </Grid>

              <Grid item xs={12}>
                <AppInput
                  label="Notas"
                  name="notes" value={ values.notes } onChange={ formik.handleChange } placeholder=""
                  error={ errors.notes } />
              </Grid>
            </Grid>

            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
              <Button className="border-0 pv8 ph16 font-weight-bold" color="brandYellow" variant="contained" disableElevation type="submit" disabled={ formik.isSubmitting }>
                { formik.isSubmitting ? "ENVIANDO..." : "CREAR" }
              </Button>
            </Box>
          </form>
        </CardContent>
      </Card>
    </Container>
  )
};

GiftCardOrderNew.propTypes = propTypes;
GiftCardOrderNew.defaultProps = defaultProps;

export default GiftCardOrderNew;
